import React, { useState, useEffect } from 'react'
import LogoImage from "../../assets/img/logo.svg";
import router from '../../router'
import Toast from "../../plugins/useToast";
import { useRecoilState } from "recoil";
import { audioPlayState } from '../../plugins/recoil';
import axios from '../../plugins/axios'
import { useTranslation } from 'react-i18next';

const Login = () => {
    const { t, i18n } = useTranslation()
    const [isSecure, setIsSecure] = useState(true)
    const [id, setId] = useState('')
    const [pass, setPass] = useState('')
    const [, setPlayAudio] = useRecoilState(audioPlayState);

    const handleLogin = async () => {
        if (!id || !pass) return
        try {
            const res = await axios.post('/auth/login', { loginId: id, password: pass })
            if (res.code != '200') throw res

            localStorage.setItem('AdmincmsUserId', res.data.cmsUserId)            
            localStorage.setItem('accessToken', res.data.token)
            localStorage.setItem('refreshToken', res.data.refreshToken)

            //여기서 로그인 못하게 처리
            const resUser = await axios.get('/user/me')            

            //일반 사용자는 접근 금지
            if(resUser.data.role == 'USER'){
                localStorage.removeItem('AdmincmsUserId', res.data.cmsUserId)            
                localStorage.removeItem('accessToken', res.data.token)
                localStorage.removeItem('refreshToken', res.data.refreshToken)
                Toast({ isSuccess: false, msg: t(`login.accessDenied`) });
                return;
            }

            if (res.data.passwordChangeRequired) {
                router.navigate('/admin/changepwd')
            } else {                
                router.navigate('/admin/main')
            }            
        } catch (err) {
            if (err.code == 2003) {
                Toast({ isSuccess: false, msg: t(`login.wrongAccount`) });
            } 
            else if (err.code == 2005) {
                Toast({ isSuccess: false, msg: t(`login.userInactive`) });
            }
            else {
                Toast({ isSuccess: false, msg: t(`login.unknownError`) });
            }
        }
    }

    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            handleLogin()
        }
    }

    useEffect(() => {
        const hasServerError = localStorage.getItem("serverError");
        if (hasServerError == "SERVER") {
            Toast({ isSuccess: false, msg: t(`login.serverError`) });
            localStorage.removeItem('serverError')
        } else if (hasServerError == 'SESSION') {
            Toast({ isSuccess: false, msg: t(`login.sessionExpired`) });
            localStorage.removeItem('serverError')
        } else if (hasServerError) {
            Toast({ isSuccess: false, msg: t(`login.unknownError`) });
            localStorage.removeItem('serverError')
        }

        //여기 만약에 userId가 있다면 자동으로 로그인 처리.
        const userId = localStorage.getItem('AdmincmsUserId');
        if (userId) {
            router.navigate('/admin/main');
        }

        const lang = localStorage.getItem('lang')
        if (lang) {
            i18n.changeLanguage(lang)
        }
    }, [])

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-[9999]">
            <div
                className="fixed inset-0 bg-[#29292E] flex items-center justify-center z-50"
                style={{
                    // backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div
                    className="w-[1080px] h-[96px] absolute top-[260px] left-1/2 ml-[-540px]"
                    style={{
                    backgroundImage: `url(${LogoImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    }}
                />
                <div className="text-[#C3C7D5] text-center font-pretendard text-[60px] font-medium leading-[120%] absolute top-[380px]">
                    {t('admin.title')}
                </div>
                <div className="absolute top-[480px] w-[512px]">
                    <div className="" style={{ backgroundColor: 'white', padding: '14px 23px', borderRadius: 8, border: '1px solid #CECECE' }}>
                        <input className='w-full' type="text" value={id} onChange={(e) => setId(e.target.value)} onKeyDown={handleEnter} placeholder={t('login.id(Email)')} style={{ backgroundColor: 'transparent', outline: 'none', border: 'none' }}/>
                    </div>
                    <div>                        
                    </div>
                    <div className="mt-3" style={{ backgroundColor: 'white', padding: '14px 23px', borderRadius: 8, border: '1px solid #CECECE' }}>
                        <div className="flex relative">
                            <input className='' type={isSecure ? 'password' : 'text'} value={pass} onKeyDown={handleEnter} onChange={(e) => setPass(e.target.value)} placeholder={t('login.password')}  style={{ backgroundColor: 'transparent', borderColor: '#c3c3c3', outline: 'none', width: '100%', paddingRight: 25 }}/>                            
                        </div>
                    </div>
                </div>
                <button
                    disabled={!id || !pass}
                    onClick={handleLogin}
                    className="w-[512px] h-[60px] bg-gradient-to-b from-[#3182F7] to-[#1562D1] text-white font-light text-[20px] rounded-[4px] transition absolute bottom-[278px] left-1/2 ml-[-256px]"
                    style={{ opacity: id && pass ? 1 : 0.4 }}
                >
                    { t('login.login') }
                </button>
            </div>
        </div>
    )
}

export default Login